import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import gameData, { GameShortNames } from '../gameData';
import FontKeys from '../FontKeys';
import TimeCountUp from './TimeCountUp';

export default class ResultsDialog extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, resultsData, newBest, newTime) {
    super(scene);

    this.newBestReached = newBest;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'results-bg', this).setOrigin(0);

    this.localAtlas = ABCyaPhaser.Images.LOCALIZATION_ATLAS;

    const goodJob = ABCyaPhaser.Localization.instance.getLocalizedString('good_job');
    const yourTime = ABCyaPhaser.Localization.instance.getLocalizedString('your_time');
    const bestTime = ABCyaPhaser.Localization.instance.getLocalizedString('best_time');

    this.coin = ABCyaPhaser.Images.addImage(0, 0, `coin-${resultsData.medal}-large`, this);
    this.coin.x = 50 + (this.coin.getBounds().width / 2);
    this.coin.y = 30 + (this.coin.getBounds().height / 2);
    this.coin.scale = 0;
    this.coin.alpha = 0;

    this.recordStarSpot = ABCyaPhaser.Images.addImage(0, 0, 'star-outline', this);
    this.recordStarSpot.x = this.coin.x;
    this.recordStarSpot.y = this.coin.y + (this.coin.height / 2) + (this.recordStarSpot.getBounds().height / 2) + 25;

    this.resultTxt = ABCyaPhaser.Text.addText(0, 0,`${45}pt`, 0x433C49, FontKeys._cloudy_with_a_chance_of_lovRg, goodJob, this, false);
    this.resultTxt.x = this.coin.x + (this.coin.width / 2) + 35;
    this.resultTxt.y = 50;
    this.resultTxt.alpha = 0;

    this.timeTxt = ABCyaPhaser.Text.addText(0, 0,`${22}pt`, 0x433C49, FontKeys._cloudy_with_a_chance_of_lovRg, yourTime, this, false).setOrigin(0, 0.5);
    this.timeTxt.x = this.resultTxt.x + 5;
    this.timeTxt.y = this.resultTxt.y + this.resultTxt.getBounds().height + 40;

    this.timeCounter = new TimeCountUp(this.scene, newTime, 22, FontKeys._cloudy_with_a_chance_of_lovRg, 0x433C49);
    this.timeCounter.x = this.timeTxt.x + this.timeTxt.getBounds().width;
    this.timeCounter.y = this.timeTxt.y;
    this.timeCounter.showFullCount();
    this.add(this.timeCounter);

    this.bestTxt = ABCyaPhaser.Text.addText(0, 0,`${22}pt`, 0x433C49, FontKeys._cloudy_with_a_chance_of_lovRg, bestTime, this, false).setOrigin(0, 0.5);
    this.bestTxt.x = this.resultTxt.x + 5;
    this.bestTxt.y = this.timeTxt.y + this.timeTxt.getBounds().height + 20;

    this.bestCounter = new TimeCountUp(this.scene, resultsData.bestTime, 22, FontKeys._cloudy_with_a_chance_of_lovRg, 0x433C49);
    this.bestCounter.x = this.bestTxt.x + this.bestTxt.getBounds().width;
    this.bestCounter.y = this.bestTxt.y;
    this.bestCounter.showFullCount();
    this.add(this.bestCounter);

    this.againBtn = ABCyaPhaser.Images.addImage(0, 0, 'btn-play-again', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0)
      .setInteractive();
    this.againBtn.x = (this.bg.getBounds().width / 2) - this.againBtn.getBounds().width - 10;

    // dirty hack since buttons for food pyramid version are too low
    const btnOffset = gameData.gameConfigs[gameData.game].GAME_TITLE === 'Food Groups' ? 30 : 20;
    this.againBtn.y = this.bg.getBounds().height - this.againBtn.getBounds().height - btnOffset;

    this.nextBtn = ABCyaPhaser.Images.addImage(0, 0, 'btn-next', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0)
      .setInteractive();
    this.nextBtn.x = (this.bg.getBounds().width / 2) + 10;
    this.nextBtn.y = this.againBtn.y;

    this.againBtn.alpha = 0;
    this.nextBtn.alpha = 0;

    this.showStepIndex = 0;

    ABCyaPhaser.Audio.playOneShot('dialog-in', this.scene, 1, false, 0, gameData.gameModeSoundAtlas);

    this.isDismissed = false;
  }

  showDialog() {
    switch (this.showStepIndex) {
      case 0:
        this.fadeIn([this.resultTxt]);
        break;
      case 1:
        this.timeTxt.alpha = 1;
        this.timeCounter.alpha = 1;
        this.countIn(this.timeCounter);
        break;
      case 2:
        this.popIn(this.coin);
        break;
      case 3:
        this.bestTxt.alpha = 1;
        this.bestCounter.alpha = 1;
        this.countIn(this.bestCounter);
        break;
      case 4:
        if (this.newBestReached) {
          const recordStar = this.scene.add.container();
          this.add(recordStar);
          ABCyaPhaser.Images.addImage(0, 0, 'record-star', recordStar);
          ABCyaPhaser.Text.addText(0, -4, 16, 0xecc41c, FontKeys._cloudy_with_a_chance_of_lovRg, ABCyaPhaser.Localization.instance.getLocalizedString('new_record'), recordStar).setLineSpacing(-2)
            .setAngle(-12)
            .setWordWrapWidth(65);
          recordStar.x = this.recordStarSpot.x;
          recordStar.y = this.recordStarSpot.y;
          recordStar.scaleX = 0;
          recordStar.scaleY = 0;
          recordStar.alpha = 0;
          this.popIn(recordStar);
        }
        else {
          this.showStepIndex++;
          this.showDialog();
        }
        break;
      case 5:
        this.fadeIn([this.againBtn,this.nextBtn]);
        break;
      case 6:
        this.showComplete();
        break;
    }
  };

  fadeIn(faders) {
    this.showStepIndex++;
    for (let i = 0; i < faders.length; i++) {
      const fader = faders[i];
      if (i === 0) {
        ABCyaPhaser.Tweens.addTween(fader, 500, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.showDialog();
        });
      }
      else {
        ABCyaPhaser.Tweens.addTween(fader, 500, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
      }
    }
  };

  popIn(popper) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._star, this.scene);

    this.showStepIndex++;

    ABCyaPhaser.Tweens.addTween(popper, 500, { alpha: 1,scaleX: 1,scaleY: 1, easeParams: [1,0.3] }, Phaser.Math.Easing.Elastic.Out, () => {
      this.scene.time.delayedCall(300, () => {this.showDialog();});
    });
  };

  countIn() {
    this.showStepIndex++;

    // this.showStepIndex = 4; // TODO REMOVE
    this.showDialog();
  };

  showComplete() {
    // add button listeners
    this.againBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.dismissResults('same level'));
    this.nextBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,() => this.dismissResults('next level'));
  };

  dismissResults(e) {
    if (this.isDismissed) return;

    this.againBtn.disableInteractive();
    this.nextBtn.disableInteractive();

    ABCyaPhaser.Audio.playOneShot('button-click', this.scene, 1, false, 0, gameData.gameModeSoundAtlas);

    this.emit('END_RESULTS_DIALOG', e);
  }
}